import gql from "../gql";
import Learning from "./Learning";
import Assignment from "./Assignment";
export default gql `
  fragment AssignedLearning on AssignedLearningSummary {
    summary {
      ...Learning
    }
    assignment {
      ...Assignment
    }
  }
  ${Learning}
  ${Assignment}
`;
